import { styled } from "styled-components";

export const CartWrapper = styled.div`
  padding: 0 24px 0 24px;
  justify-content: flex-start;
`;
